import PropTypes from 'prop-types'
import { Fragment, useMemo } from 'react'
import { connect } from 'react-redux'
import { customFlagValue, isFlagEligible } from 'lib/utils/handle-flag/const'
import { checkApplicableVoucher } from 'components/pdp/carousel-images/voucher/voucher-checkout/utils'
import { getVoucherDesc } from 'components/pdp/carousel-images/voucher/utils'
import compose from 'recompose/compose'
import { withI18next } from 'lib/i18n/withI18next'
import Typo from 'constants/typography'
import CartProduct from '../cart-product'
import CartDiamondDealBanner from '../cart-diamond/cart-diamond-deal-banner/CartDiamondDealBanner'
import style from './cart-items.scss'

const CartItems = ({
  t,
  allowProductUpdate,
  cartProducts,
  fromSummary,
  refType,
  setError,
  isProductUpdated,
  showFallbackModal,
}) => {
  const voucherCheckoutNewErrorFlagValue = customFlagValue({
    flagName: 'voucherCheckout',
  })
  const productItems = useMemo(
    () =>
      cartProducts?.items?.map((product) => ({
        ...product,
        selectedAttributes: product.attributes.find(({ selected }) =>
          Boolean(selected),
        ),
      })),
    [cartProducts],
  )
  const hasDiamondProductInCart = (cartProducts?.items || []).some(
    (product) => product.type === 'diamond',
  )
  const isShowDiamondDealBanner = Boolean(cartProducts?.diamond_info?.deal)

  const shoppingBagRedesignFlagValue = customFlagValue({
    flagName: 'shoppingBagRedesign',
  }) // TODO: force value to handle with flagsmith later (ShoppingBagRedesign-20230101)
  const isShoppingBagNewDesign = isFlagEligible(shoppingBagRedesignFlagValue)

  const getDiamondVoucherNote = () => {
    const diamondVoucher = {
      ...cartProducts?.diamond_info?.voucher,
      is_applicable: 1,
    }
    const applicableDiamondVoucher = checkApplicableVoucher(
      diamondVoucher,
      cartProducts.items,
      cartProducts.summary.subtotal,
      voucherCheckoutNewErrorFlagValue,
    )
    const note = !applicableDiamondVoucher?.is_applicable
      ? getVoucherDesc(
          !applicableDiamondVoucher?.is_applicable,
          applicableDiamondVoucher,
          t,
        )
      : ''
    return note
  }

  const diamondVoucherNote = cartProducts?.diamond_info?.voucher
    ? getDiamondVoucherNote()
    : null

  if (!cartProducts?.items) {
    return null
  }

  return (
    <Fragment>
      <style jsx>{style}</style>
      <div className="cart-items">
        {!hasDiamondProductInCart && isShowDiamondDealBanner && (
          <CartDiamondDealBanner dealInfo={cartProducts?.diamond_info?.deal} />
        )}
        {productItems.map((product, idx) => (
          <div key={product.id_product}>
            <CartProduct
              key={product.id_product}
              allowProductUpdate={allowProductUpdate}
              showMoveToBagCoachmark={idx === 0}
              fromSummary={fromSummary}
              product={product}
              refType={refType}
              selectedAttribute={product.selectedAttributes}
              setError={setError}
              isProductUpdated={isProductUpdated}
              showFallbackModal={showFallbackModal}
              isShoppingBagNewDesign={isShoppingBagNewDesign}
            />
            {hasDiamondProductInCart &&
              idx === 0 &&
              isShowDiamondDealBanner && (
                <CartDiamondDealBanner
                  dealInfo={cartProducts?.diamond_info?.deal}
                />
              )}
          </div>
        ))}
        {diamondVoucherNote && (
          <div className="cart-items__discount-voucher-note">
            <div className={Typo.caption}> {diamondVoucherNote}</div>
          </div>
        )}
      </div>
    </Fragment>
  )
}

CartItems.defaultProps = {
  allowProductUpdate: undefined,
  cartProducts: undefined,
  fromSummary: false,
  refType: 'bag',
  setError: undefined,
  isProductUpdated: undefined,
  showFallbackModal: undefined,
}

CartItems.propTypes = {
  allowProductUpdate: PropTypes.bool,
  cartProducts: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
    diamond_info: PropTypes.shape({
      deal: PropTypes.string,
      voucher: PropTypes.shape({}),
    }),
    summary: PropTypes.shape({
      subtotal: PropTypes.number,
    }),
  }),
  fromSummary: PropTypes.bool,
  setError: PropTypes.func,
  refType: PropTypes.string,
  isProductUpdated: PropTypes.func,
  showFallbackModal: PropTypes.func,
  t: PropTypes.func.isRequired,
}

export default compose(
  connect((state) => ({
    isPhone: state.device.isPhone,
    cartProducts: state.cart.payload,
  })),
  withI18next(),
)(CartItems)
